import dayjs from "dayjs";
import { CAMPAIGN_NAME_SEPARATOR } from "../../../utils/constants";

const buildCampaignNameString = (
  brandShortName,
  advertiserShortName,
  broadcastingDate
) => {
  const brandName = brandShortName
    ? advertiserShortName === brandShortName
      ? ""
      : ` ${CAMPAIGN_NAME_SEPARATOR} ${brandShortName}`
    : ` ${CAMPAIGN_NAME_SEPARATOR} [Brand]`;
  const date = dayjs(broadcastingDate).isValid()
    ? dayjs(broadcastingDate).format("YYYY-MM")
    : "[Broadcasting date]";

  const result = `${date} ${CAMPAIGN_NAME_SEPARATOR} ${
    advertiserShortName || "[Advertiser]"
  }${brandName}`;

  return result.slice(0, 59);
};

export default buildCampaignNameString;
